import Vue from "vue";
import Router from "vue-router";


const includPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return includPush.call(this, location).catch(err => err)

}
Vue.use(Router);

const router = new Router({
  routes: [
    {
      path:"/",
      redirect:'/remindMeds'
    },
    {
      path: "/remindMeds",
      name: "remindMeds",
      meta: {
        showFooter: true,
        keepAlive: true
      },
      component: () => import("@/components/new/remindMeds.vue") //服药提醒入口页面
    },
    {
      path: "/miniRemind",
      name: "miniRemind",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/reminder/miniRemindList.vue") //服药提醒入口页面
    },
    {
      path: "/healthCalendar",
      name: "healthCalendar",
      meta: {
        showFooter: true,
        keepAlive: true
      },
      component: () => import("@/components/healthCalendar/healthCalendar.vue") //健康日历
    },

    {
      path: "/testDemo",
      name: "textDemo",
      component: () => import("@/components/textDemo/index.vue") //新页面添加用药提醒
    },

    {
      path: "/addVirtualMedicine",
      name: "addVirtualMedicine",
      component: () =>
        import("@/components/medicine_chest/addVirtualMedicine.vue") //新页面添加用药提醒
    },
    {
      path: "/shareMember",
      name: "shareMember",
      component: () =>
        import("@/components/medicine_chest/shareMember.vue") //添加共享成员
    },
    {
      path: "/addShareMember",
      name: "addShareMember",
      component: () =>
        import("@/components/medicine_chest/addShareMember.vue") //添加共享成员
    },
    {
      path: "/medicineIntroduce",
      name: "medicineIntroduce",
      component: () =>
        import("@/components/medicine_chest/medicineIntroduce.vue") //药箱说明
    },
    // {
    //   path: "/shareVirtual",
    //   name: "shareVirtual",
    //   component: () =>
    //     import("@/components/medicine_chest/shareVirtual.vue") //新页面添加用药提醒 分享
    // },
    {
      path: "/checkVirtualList",
      name: "checkVirtualList",
      component: () =>
        import("@/components/medicine_chest/checkVirtualList.vue") //药箱
    },
    {
      path: "/new/me/index",
      name: "/new/me/index",
      component: () => import("@/components/new/me/index.vue") //新页面添加用药提醒
    },
    // {
    //   path: "/virtualMedicine",
    //   name: "virtualMedicine",
    //   meta: {
    //     showFooter: true,
    //     keepAlive: true
    //   },
    //   component: () => import("@/components/new/virtual/index.vue") //药箱
    // },
    {
      path: "/virtualMedicine",
      name: "virtualMedicine",
      meta: {
        showFooter: true,
        keepAlive: true
      },
      component: () => import("@/components/new/virtual/indexCopy.vue") //药箱
    },
    {
      path: "/score",
      name: "score",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/new/score/index.vue") //评分
    },

    {
      path: "/gradingsp",
      name: "gradingsp",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/new/gradingsp/index.vue") //评分说明
    },
    // 原官网
    // {
    //   name: "keepOnRecord",
    //   path: "/keepOnRecord",
    //   component: require("@/components/keepRecord/keepOnRecord.vue").default
    // },
    // {
    //   name: "keepOnRecord",
    //   path: "/keepOnRecord",
    //   component: require("@/components/keepRecord/keepOnIndex.vue").default
    // },
    // {
    //   name: "calendar",
    //   path: "/calendar",
    //   component: () =>
    //     import("@/components/keepRecord/cpn/calendar/calendar.vue")
    // },
    {
      name: "/noNetwork",
      path: "noNetwork",
      // component: () => import('@/components/errorStatus/noNetwork.vue')//新增服药入口
      component: require("@/components/errorStatus/noNetwork.vue").default
    },
    {
      path: "/reminder",
      name: "reminder",
      meta: {
        showFooter: true
      },
      component: () => import("@/components/reminder/reminder.vue") //新增服药入口
    },
    {
      path: "/addFlag",
      name: "addFlag",
      component: () => import("@/components/flag/addFlag.vue") //新增Flag
    },
    {
      path: "/addFlag01",
      name: "addFlag01",
      component: () => import("@/components/flag/addFlag01.vue") //新增Flag新版
    },
    {
      path: "/flags",
      name: "flags",
      component: () => import("@/components/flag/flags.vue") //新增Flag
    },
    {
      path: "/relationMember",
      name: "relationMember",
      component: () => import("@/components/common/relationMember.vue") //新增Flag
    },
    {
      path: "/flagsDetails",
      name: "flagsDetails",
      component: () => import("@/components/flag/flagsDetails.vue") //新增Flag
    },
    {
      path: "/addReminder",
      name: "addReminder",
      component: () => import("@/components/reminder/addReminder.vue"), //新增服药
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/addRecheck",
      name: "addRecheck",
      component: () => import("@/components/recheck/addRecheck.vue"), //复查复诊
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/recheckList",
      name: "recheckList",
      component: () => import("@/components/recheck/recheckList.vue") //复查复诊历史
    },
    {
      path: "/demo",
      name: "demo",
      component: () => import("@/components/demo/index.vue") //demo页面
    },
    {
      path: "/editReminder",
      name: "editReminder",
      component: () => import("@/components/reminder/editReminder.vue") //编辑服药
    },
    {
      path: "/remindRecord",
      name: "remindRecord",
      component: () => import("@/components/reminder/remindRecord.vue") //用药记录
    },
    {
      path: "/remindDetails",
      name: "remindDetails",
      component: () => import("@/components/reminder/remindDetails.vue") //服药详情
    },
    {
      path: "/my",
      name: "my",
      meta: {
        showFooter: true,
        keepAlive: true
      },
      component: () => import("@/components/new/me/index.vue") //新页面添加用药提醒
      //component: () => import('@/components/my/my.vue')//我的
    },

    {
      path: "/serviceSuggestions",
      name: "serviceSuggestions",
      component: () => import("@/components/my/serviceSuggestions.vue") //您的建议
    },
    {
      path: "/registeringAccount",
      name: "registeringAccount",
      // meta: {
      //   showFooter: false
      // },
      component: () => import("@/components/my/registeringAccount.vue") //注册
    },
    {
      path: "/setting",
      name: "setting",
      component: () => import("@/components/my/setting.vue") //设置页面
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/components/my/login.vue") //登录
    },
    {
      path: "/loginSelect",
      name: "loginSelect",
      component: () => import("@/components/my/loginSelect.vue") //验证码登录
    },
    {
      path: "/loginPassword",
      name: "loginPassword",
      component: () => import("@/components/my/loginPassword.vue") //账号密码登录
    },
    {
      path: "/forgotPassword",
      name: "forgotPassword",
      component: () => import("@/components/my/forgotPassword.vue") //忘记密码
    },
    {
      path: "/privacyPolicy",
      name: "privacyPolicy",
      component: () => import("@/components/common/privacyPolicy.vue") //隐私政策
    },
    {
      path: "/gamePrivacyPolicy",
      name: "gamePrivacyPolicy",
      component: () => import("@/components/common/gamePrivacyPolicy.vue") //趣味2048隐私政策
    },
    {
      path: "/reminder/querySystemReminder",
      name: "/reminder/querySystemReminder",
      component: () => import("@/components/reminder/querySystemReminder.vue") //提醒方式选择
    },
    {
      path: "/memberFamily",
      name: "memberFamily",
      component: () => import("@/components/my/memberFamily.vue") //添加家庭成员
    },
    {
      path: "/addMember",
      name: "addMember",
      component: () => import("@/components/common/addMember.vue") //家庭弹框
    },
    {
      path: "/medicalRecord",
      name: "medicalRecord",
      meta: {
        showFooter: true,
        keepAlive: true
      },
      component: () => import("@/components/medicalRecord/medicalRecord.vue") //病历
    },

    {
      path: "/addCase",
      name: "addCase",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/medicalRecord/addCase.vue") //病历
    },
    {
      path: "/medicalRecordDetails",
      name: "medicalRecordDetails",
      meta: {
        showFooter: false
      },
      component: () =>
        import("@/components/medicalRecord/medicalRecordDetails.vue") //病历
    },
    {
      path: "/medicalRecordImg",
      name: "medicalRecordImg",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/medicalRecord/medicalRecordImg.vue") //诊单图片页面
    },

    {
      path: "/community1/index",
      name: "community1/index",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/community1/index.vue") //社区广场
    },
    // {
    //   path: '/vcalendar',
    //   name: 'vcalendar',
    //   meta: {
    //     showFooter: false
    //   },
    //   component: () => import('@/components/vcalendar/vcalnedar.vue')//社区广场
    // },
    {
      path: "/vcalendar",
      name: "vcalendar",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/vcalendar/vcalnedar.vue") //病历
    },

    {
      path: "/community1/detail",
      name: "community1/detail",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/community1/detail.vue") //广场明细
    },
    {
      path: "/community1/my",
      name: "community1/my",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/community1/my.vue") //广场明细
    },
    {
      path: "/community1/publish",
      name: "community1/publish",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/community1/publish.vue") //广场明细
    },
    {
      path: "/community1/setup",
      name: "community1/setup",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/community1/setup.vue") //广场明细
    },
    {
      path: "/community1/admin/audit",
      name: "community1/admin/audit",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/community/admin/audit.vue") //广场明细
    },
    {
      path: "/community/admin/editPromotion",
      name: "community/admin/editPromotion",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/community/admin/editPromotion.vue") //编辑推广
    },
    {
      path: "/community/index",
      name: "community/index",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/community/index.vue") //社区急诊
    },
    {
      path: "/community/common/status1",
      name: "community/common/status1",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/community/common/status1.vue") //状态已帮助
    },

    // {
    //   path: '/map2',
    //   name: 'map2',
    //   meta: {
    //     showFooter: false
    //   },
    //   component: () => import('@/components/newmap/map2.vue')//状态已帮助
    // },
    // {
    //   path: '/map3',
    //   name: 'map3',
    //   meta: {
    //     showFooter: false
    //   },
    //   component: () => import('@/components/newmap/map3.vue')//状态已帮助
    // },
    {
      path: "/newmap",
      name: "newmap",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/newmap/newmap.vue") //状态已帮助
    },

    // {
    //   path: '/A/map',
    //   name: 'A/map',
    //   meta: {
    //     showFooter: false
    //   },
    //   component: () => import('@/components/newmap/A/map.vue')//状态已帮助
    // },

    // {
    //   path: '/map1',
    //   name: 'map1',
    //   meta: {
    //     showFooter: false
    //   },
    //   component: () => import('@/components/newmap/map1.vue')//状态已帮助
    // },
    // {
    //   path: '/AMap',
    //   name: 'AMap',
    //   meta: {
    //     showFooter: false
    //   },
    //   component: () => import('@/components/newmap/AMap.vue')//状态已帮助
    // },
    // {
    //   path: '/map',
    //   name: 'map',
    //   meta: {
    //     showFooter: false
    //   },
    //   component: () => import('@/components/newmap/map.vue')//状态已帮助
    // },
    // {
    //   path: '/newmap/home',
    //   name: 'newmap/home',
    //   meta: {
    //     showFooter: false
    //   },
    //   component: () => import('@/components/newmap/home.vue')//状态已帮助
    // },

    {
      path: "/community/common/status2",
      name: "community/common/status2",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/community/common/status2.vue") //状态已解决
    },
    {
      path: "/community/admin/index",
      name: "community/admin/index",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/community/admin/index.vue") //审核首页
    },
    {
      path: "/community/admin/audit",
      name: "community/admin/audit",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/community/admin/audit.vue") //审核详情
    },

    {
      path: "/community/index",
      name: "community/index",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/community/index.vue") //社区首页
    },
    {
      path: "/community/my",
      name: "community/my",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/community/my.vue") //我的
    },
    {
      path: "/community/detail",
      name: "community/detail",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/community/detail.vue") //详情
    },
    {
      path: "/community/setup",
      name: "community/setup",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/community/setup.vue") //详情
    },
    {
      path: "/community/publish",
      name: "community/publish",
      meta: {
        showFooter: false
      },
      component: () => import("@/components/community/publish.vue") //发布
    },
    {
      path: "/notice",
      name: "notice",
      component: () => import("@/components/my/notice.vue") //添加药物
    },
    {
      path: "/addPushMessage",
      name: "addPushMessage",
      component: () => import("@/components/my/addPushMessage.vue") //添加药物
    },
    {
      path: "/accountDetails",
      name: "accountDetails",
      component: () => import("@/components/my/accountDetails.vue") //添加药物
    },
    {
      path: "/privacyPolicy",
      name: "privacyPolicy",
      component: () => import("@/components/common/privacyPolicy.vue") //隐私政策
    },
    {
      path: "/userAgreement",
      name: "userAgreement",
      component: () => import("@/components/common/userAgreement.vue") //隐私政策
    },
    {
      path: "/reload",
      name: "reload",
      component: () => import("@/components/common/reload.vue") //强制刷新
    },
    {
      path: "/addNucleicAcid",
      name: "addNucleicAcid",
      component: () => import("@/components/reminder/addNucleicAcid.vue") //新增核酸
    },
    // {
    //   path: "/login1",
    //   name: "login1",
    //   component: () => import("@/components/keepRecord/login1.vue") //审核页面登录
    // },
    {
      path: "/editDailyTips",
      name: "editDailyTips",
      component: () => import("@/components/reminder/editDailyTips.vue") //编辑提示语
    },
    {
      path: "/queryNucleicAcid",
      name: "queryNucleicAcid",
      meta: {
        showFooter: true
      },
      component: () => import("@/components/reminder/queryNucleicAcid.vue") //新增核酸
    },
    {
      path: "/help/help",
      name: "help",
      component: () => import("@/components/help/help.vue") //互助
    },
    {
      path: "/help/helpPrivacyPolicy",
      name: "helpPrivacyPolicy",
      component: () => import("@/components/help/helpPrivacyPolicy.vue") //互助隐私政策
    },
    {
      path: "/water",
      name: "water",
      component: () => import("@/components/water/water.vue") //喝水页面
    },
    {
      path: "/water2",
      name: "water2",
      component: () => import("@/components/water/water2.vue") //喝水页面
    },
    {
      path: "/Versionlog",
      name: "Versionlog",
      component: () => import("@/components/Versionlog/Versionlog.vue") //喝水页面
    },
    {
      path: "/aboutUs",
      name: "aboutUs",
      component: () => import("@/components/my/aboutUs.vue") //喝水页面
    },
    {
      path: "/invite/:id",
      name: "invite",
      component: () => import("@/components/medicine_chest/invite.vue") //共享药箱短信邀请页面
    },
    {
      path: "/inviteRegiste",
      name: "inviteRegiste",
      component: () => import("@/components/medicine_chest/inviteRegiste.vue") //共享药箱短信邀请页面
    }
  ]
});
export default router;

// 全局前置守卫(在路由跳转之前操作)
router.beforeEach((to, from, next) => {
  if(localStorage.getItem('miniRemind') == 'true'){
    if(to.name != 'miniRemind') next('/miniRemind')
    else next()
  }else {

    next()
  }
  // window.axiosArr.forEach((el,index)=>{
  //   el.cancel();
  //   delete window.axiosArr[index]
  // })

});



// WEBPACK FOOTER //
// ./src/router/index.js